import { makeRequestAction } from './index';

export const getCountries = makeRequestAction('GET_COUNTRIES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
